(function ($) {
    'use strict';
    $(document).ready(function () {

        $('a.nav-link.dropdown-toggle').click(function () {
            location.href = this.href;
        });

        $.each($('.tiles-with-link .wp-block-column >.wp-block-group'), function () {
            var button__link = $(this).find('h3 a').attr('href'); // any link in the tile
            $(this).wrap('<a href="' + button__link + '" class="tile-link"></a>');
        });


        // ======================================
        // Image Library filter
        //
        let filterParam = { ws_img_filter_product_category: {}, ws_img_filter_room: {}, ws_img_filter_quality: {} };
        let filtersBlock = $('.ws-img-gallery .header-gallery .filters');
        let imageList = $('.ws-img-gallery .image-list');

        filtersBlock.find('.checkbox-option input[type="checkbox"]').on('click', function (e) {
            let nameF = $(this).attr('filterName');
            let nameO = $(this).attr('name');
            let value = $(this).attr('value');
            let checked = $(this).prop("checked");

            if (checked) {
                filterParam[nameF][nameO] = value;
            } else {
                delete(filterParam[nameF][nameO]);
            }

            reloadFilter();
        });

        // change the list according to the filter
        function reloadFilter() {
            $.each( imageList.find(".image-block"), function( key, img ) {

                let filterValueImg = {};
                let filterValueJson = $(img).attr('filter-value');
                if (typeof filterValueJson !== 'undefined' && filterValueJson) {
                    filterValueImg = $.parseJSON(filterValueJson);
                }

                let showImageByParam = [];

                for (let fSlug in filterParam) {
                    let fValues = filterParam[fSlug];
                    showImageByParam[fSlug] = false;

                    if (0 === Object.keys(fValues).length) {
                        showImageByParam[fSlug] = true;

                    } else {
                        if (typeof filterValueImg[fSlug] === 'object') {
                            filterValueImg[fSlug].forEach(function ( imgFilterValue ) {
                                for (let oSlug in fValues) {
                                    if ( fValues[oSlug] === imgFilterValue ) {
                                        showImageByParam[fSlug] = true;
                                        break;
                                    }
                                }
                            });
                        }
                    }
                }

                let showImage = true;
                for (let fSlug in showImageByParam) {
                    if (!showImageByParam[fSlug]) {
                        showImage = false;
                    }
                }
                if (showImage && !$(img).is(":visible")) {
                    $(img).show();
                }
                if (!showImage && $(img).is(":visible")) {
                    $(img).hide();
                }

            });
        }

        // ======================================
        // Image Library view switcher
        //
        let typeViewBlock = $('.ws-img-gallery .header-gallery .type-of-view');
        let styleList_ib = 'col-md-12 col-sm-12 col-xs-12';
        let styleGrid_ib = 'col-md-4 col-sm-6 col-xs-6';
        let styleList_c = 'col';
        let styleGrid_c = '';

        typeViewBlock.find('a.grid').on('click', function (e) {
            imageList.removeClass('list').addClass('grid');
            imageList.find('div.image-block').removeClass(styleList_ib).addClass(styleGrid_ib);
            imageList.find('div.image-block .card').removeClass(styleList_c).addClass(styleGrid_c);
        });
        typeViewBlock.find('a.list').on('click', function (e) {
            imageList.removeClass('grid').addClass('list');
            imageList.find('div.image-block').removeClass(styleGrid_ib).addClass(styleList_ib);
            imageList.find('div.image-block .card').removeClass(styleGrid_c).addClass(styleList_c);
        });

        // ======================================
        // Image Gallery switcher
        //
        previewer = $('.ws-img-gallery .image-previewer');
        leftNav  = previewer.find('.previewer-navigator.left')[0];
        rightNav = previewer.find('.previewer-navigator.right')[0];

        let imgFile = $('.ws-img-gallery .image-list .image-block .card img');
        imgFile.on('click', function (e) {
            let previewImage = $(this).attr('preview-image');

            prevSibling = getPrevVisibleSibling($(this).parent().parent());
            nextSibling = getNextVisibleSibling($(this).parent().parent());

            showPreviewer(previewImage);
        });

        previewer.on('click', function (e) {
            if (e.target.className === 'image-previewer') {
                hidePreviewer();
            }
        });

    });

    // is it mobile screen?
    var is_mobile = false;
    if( jQuery('#mobile-checker-for-js').css('display')==='none') {
        is_mobile = true;
    }

    $(document).on('click', '.search-main-nav .button-close', function (e) {
        e.preventDefault();
        hideSearchBlock();
    });
    $(document).on('click', '.site-navbar-top-right .search-button', function (e) {
        e.preventDefault();
        showSearchBlock();
    });


    function showSearchBlock() {
        let el = jQuery("#navbarToggleSearchForm");
        el.animate({ marginRight: "+=420px" });
    }
    function hideSearchBlock() {
        let el = jQuery("#navbarToggleSearchForm");
        el.animate({ marginRight: "-=420px" });
    }


    // ============== Image Gallery ========================
    let previewer = null;
    let leftNav  = null;
    let rightNav = null;
    let prevSibling = null;
    let nextSibling = null;

    function clickNavigatorLeft(e) {
        if (prevSibling !== null) {
            prevSibling.find('.card img').click();
        } else {
            hidePreviewer();
        }
    }
    function clickNavigatorRight(e) {
        // console.log(e);
        if (nextSibling !== null) {
            nextSibling.find('.card img').click();
        } else {
            hidePreviewer();
        }
    }

    function cleanPreviewerBlock() {
        previewer.find('.slide-block img').attr('src', '#');
        leftNav.removeEventListener("click", clickNavigatorLeft);
        rightNav.removeEventListener("click", clickNavigatorRight);
    }

    function showPreviewer(imgFile) {
        cleanPreviewerBlock();

        previewer.find('.slide-block img').attr('src', imgFile);
        leftNav.addEventListener('click', clickNavigatorLeft);
        rightNav.addEventListener('click', clickNavigatorRight);

        previewer.show();
    }
    function hidePreviewer() {
        cleanPreviewerBlock();
        prevSibling = null;
        nextSibling = null;
        previewer.hide();
    }

    function getPrevVisibleSibling(el) {
        let prevSibling = null;
        let prevEl = el.prev();
        while ( prevEl.length>0) {
            if ($(prevEl).is(":visible")) {
                prevSibling = prevEl;
                break;
            }
            prevEl = prevEl.prev();
        }
        return prevSibling;
    }
    function getNextVisibleSibling(el) {
        let nextSibling = null;
        let nextEl = el.next();
        while ( nextEl.length>0) {
            if ($(nextEl).is(":visible")) {
                nextSibling = nextEl;
                break;
            }
            nextEl = nextEl.next();
        }
        return nextSibling;
    }
    // ----------------- Image Gallery ----------------------- //


    // https://stackoverflow.com/questions/7478336/only-detect-click-event-on-pseudo-element
    // check clicked offset width to check if user clicked on downarrow button......
    $(document).on('click', '.primary-menu li.menu-item-has-children a', function (e) {
        if (e.offsetX > $(this).width() - 20) {
            e.preventDefault();
            $(this).parent().toggleClass('megamenu-toggle');
        } else {
            // go to link
        }
    });


    $(window).load(function () {});
})(jQuery);
